/**
 * Node Modules
 */
import React from 'react'
import { Helmet } from 'react-helmet'
import { graphql } from 'gatsby'

/**
 * Application Modules
 */
import PageContainer from '../../components/page-container'
import Metadata from '../../components/metadata'
import Footer from '../../components/footer'

import Hero from '../../sections/our-values/hero'
import KeyValue from '../../sections/our-values/key-value'
import DownloadBanner from '../../components/download-banner'

/**
 * Page Component
 */
export default function Page({ data }) {
  const {
    referencePageMetadata,
    heroDek,
    heroHed,
    valuesDekA,
    valuesDekB,
    valuesDekC,
    valuesDekD,
    valuesHedA,
    valuesHedB,
    valuesHedC,
    valuesHedD,
    valuesLinksA,
    valuesLinksB,
  } = data.contentfulSingletonOurValues

  return (
    <PageContainer>
      <Helmet>
        <link rel="canonical" href="https://kinzoo.com/our-values/" />
        <meta property="og:url" content="https://kinzoo.com/our-values/" />
      </Helmet>
      <Metadata {...referencePageMetadata} />
      <Hero hed={heroHed} dek={heroDek.heroDek} />
      <KeyValue
        hed={valuesHedA}
        dek={valuesDekA.valuesDekA}
        links={valuesLinksA}
        img={'/our-values/safety.png'}
        className="first"
      />
      <KeyValue hed={valuesHedB} dek={valuesDekB.valuesDekB} links={valuesLinksB} img={'/our-values/empathy.png'} />

      <div className="key-value-seperator">
        <svg viewBox="0 0 1283 230" className="key-value-seperator__curve">
          <path
            fill="#F7F7F7"
            fillRule="evenodd"
            d="M1241.966 0c14.139 0 27.817.675 41.035 2.026L1283 230H-.002v-13.83c75.299-43.32 159.495-64.981 252.587-64.981 203.69 0 284.194 64.254 493.125 64.254C954.64 215.443 1009.519 0 1241.966 0z"
          />
        </svg>
      </div>

      <KeyValue
        hed={valuesHedC}
        dek={valuesDekC.valuesDekC}
        img={'/our-values/transparency.png'}
        className="charter-key-value--gray charter-key-value--unpadded"
      />
      <KeyValue
        hed={valuesHedD}
        dek={valuesDekD.valuesDekD}
        img={'/our-values/growth.png'}
        className="last charter-key-value--gray"
      />
      <DownloadBanner />
      <Footer />
    </PageContainer>
  )
}

export const pageQuery = graphql`
  query CharterPageQuery {
    contentfulSingletonOurValues(contentful_id: { eq: "Jzxf2YF5OkKD5VkWmgEfK" }) {
      referencePageMetadata {
        pageTitle
        ogTitle
        twitterTitle
        description
        ogDescription
        twitterDescription
        ogImage {
          file {
            url
          }
        }
        twitterImage {
          file {
            url
          }
        }
      }

      id
      heroDek {
        heroDek
      }
      heroHed
      valuesDekA {
        valuesDekA
      }
      valuesDekB {
        valuesDekB
      }
      valuesDekC {
        valuesDekC
      }
      valuesDekD {
        valuesDekD
      }
      valuesHedA
      valuesHedB
      valuesHedC
      valuesHedD
      valuesLinksA {
        href
        text
      }
      valuesLinksB {
        href
        text
      }
    }
  }
`
